// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Datakauppias",
        "pull_refresh": "Vedä",
        "release_refresh": "Vapauttaa",
        "refresh_loading": "Lataaminen...",
        "footer_text": "Palvelut tarjoaa Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Etsi maa/alue",
        "my_flow": "Minun tietoni",
        "charge_code": "Kuponkikoodi",
        "coupons": "Kupongit",
        "local_package": "Paikalliset tiedot",
        "more": "Lisää",
        "popular_destination": "Maa/alue",
        "buy_now": "Ostaa nyt",
        "package_useing": "Aktiivinen",
        "unused": "Epäaktiivinen",
        "download_app": "Lataa sovellus",
        "enter_the_mall_list": "Siirry ostoskeskukseen",
        "no_data": "Ei vielä tietoja",
        "no_data_available": "Ei tietoja saatavilla",
        "copy_success": "Kopiointi onnistui",
        "copy_fail": "Kopiointi epäonnistui",
        "meritsTitle": "Mitkä ovat etuisuudet?",
        "merits1": "Ei SIMiä tarvita & Ei kuukausimaksuja",
        "merits2": "Integroitu top 2-3 operaattorin kanssa automaattista verkkoswitchausta varten",
        "go_buy": "Osta nyt",
        "instant_savings": "Säästä",
        "expires_in": "Vanhenee",
        "download_app_tips": "Lataa sovellus saadaksesi enemmän tarjouksia ja kokemuksia"
    },
    "packages": {
        "sub_title": {
            "us": "Lukuun ottamatta Guamia, Saipania",
            "it": "Mukaan lukien Vatikaanin kaupunki, San Marino",
            "va": "Mukaan lukien Italia, San Marino",
            "sm": "Mukaan lukien Italia, Vatikaanikaupunki",
            "ma": "Mukaan lukien Länsi -Sahara",
            "eh": "Mukaan lukien Marokko",
            "ch": "Mukaan lukien liechtenstein",
            "li": "Mukaan lukien Sveitsi",
            "fr": "Kansallisarvoineen Monacolla",
            "mc": "Mukaan lukien Ranska",
            "fi": "Mukaan lukien Alananin saaret",
            "ax": "Mukaan lukien Suomi",
            "gu": "Mukaan lukien Pohjois -Mariana -saaret",
            "mp": "Mukaan lukien Guam"
        },
        "unlimited_packages": "Rajoittamaton tietopaketti",
        "normal_packages": "Normaali datapaketti",
        "multi_region_packages": "Monen alueen",
        "regional_data": "Alueelliset tiedot",
        "high_speed_text": "nopea tieto",
        "infiniteFlow": "Rajattomat tiedot",
        "unLimitData": "Rajaton",
        "high_speed_text_year": "Nopea/MP",
        "package_list": "Pakettien luettelo",
        "special_offer": "Tarjoukset",
        "first_month": "1. Kuukausi",
        "periodUnit": {
            "day": "päivä (päivät)",
            "month": "kuukausi",
            "hour": "tunti (t)",
            "year": "vuosi"
        },
        "periodUnits": {
            "day": "päivä (päivät)",
            "month": "kuukausi",
            "hour": "tunti (t)",
            "year": "vuotta"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "puolesta",
            "hour": "h",
            "year": "de"
        },
        "periodUnitMonthly":"Kuukausittainen",
        "periodUnitsSimp": {
            "day": "d",
            "month": "puolesta",
            "hour": "h",
            "year": "de"
        },
        "unlimited_good_name": {
            "day": "Päivänpääsy",
            "month": "Kuukausilippu",
            "year": "Vuotuinen passi"
        },
        "continuousMonth": "Jatkuvat kuukaudet",
        "continuousDay": "Jatkuvia päiviä",
        "continuousYear": "Jatkuvia vuosia",
        "day_invalid": "Vanhenee nykypäivänä",
        "month_invalid": "Vanhenee kuluvana kuukaudessa",
        "immediate_valid": "Voimaan heti",
        "tomorrow_day_valid": "Voimaan seuraavasta päivästä",
        "tomorrow_month_valid": "Ensi kuussa",
        "detail": {
            "cell_flow": "Tiedot",
            "cell_period": "Pätevyys",
            "buy_quantity": "Määrä",
            "use_area": "Kattavuus",
            "use_intro": "Ehdot",
            "buy_btn": "Tilata",
            "pay": "Maksaa",
            "buy_tips": "Sinulla on %@packageName-paketti käytössä. Haluatko ostaa tämän paketin?",
            "haveOrderTips": "Maksua odottava tilaus luotu. Klikkaa Vahvista siirtyäksesi tietosivulleni！"
        },
        "confirm": {
            "title": "Tilausvahvistus",
            "real_pay_amount": "Maksettu määrä",
            "online_payment": "Online -maksu",
            "create_order_error": "Asennus epäonnistui"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Tilauksen tilan saaminen…",
            "buy_success": "Tilata",
            "buy_pending": "Odotettaessa vahvistusta",
            "buy_pending_tip": "Maksu prosessissa… Jos maksua ei siirretty 10 minuutin sisällä, ota meihin yhteyttä tukeaksesi.",
            "get_payment_info_fail": "Maksutietojen hankinta epäonnistui",
            "cell_package": "Paketti",
            "cell_buy_amount": "Välisumma",
            "cell_real_amount": "Maksettu määrä",
            "go_to_order_btn": "Mene pakettiini",
            "back_home": "Takaisin kotiin",
            "back_mall": "Takaisin ostoskeskukseen",
            "ordersn_empty": "Tilaus sn ei voi olla tyhjä",
            "order_search_error": "Odottamaton virhe",
            "goodsName":'Tuotteen nimi'
        },
        "fail": {
            "payment_fail": "Maksu epäonnistui",
            "back_home": "Takaisin kotiin"
        }
    },
    "CountryGroup": {
        "title": "Maa-/alue",
        "placeholder": "Etsi maa tai alue",
        "clear": "Selkeä",
        "history": "Hakuhistoria"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kuponkikoodi",
            "minititle": "Kuponkikoodi",
            "input": "Anna täydennyskoodi",
            "explain": "Vinkkejä: Kosketa oikeassa yläkulmassa olevaa skannauspainiketta skannataksesi tositekortin QR -koodin tai syötä tositteen koodi manuaalisesti, jos se ei toimi.",
            "submit": "Lähettää",
            "exchange": "Lunastaa",
            "cancel": "Peruuttaa",
            "Inquiry": "Oletko varma, että vaihdat",
            "ErrorCode": "Latauskoodivirhe"
        },
        "recharge_success": {
            "package": "Paketti",
            "content": "Lunastettu onnistuneesti",
            "back": "Takaisin ostoskeskukseen",
            "view_packets": "Mene pakettiini"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktivoitu",
            "isFirst": "Priorisoitu",
            "toFirst": "Asettaa etusijalle",
            "inactive": "Inaktivoitu"
        },
        "periodUnits": {
            "minute": "minuutti (s)",
            "hour": "tunti (t)",
            "day": "päivä (päivät)",
            "month": "kuukausi (t)"
        },
        "useIntro": {
            "tip1": "Rajoittamattomalla tietopaketilla on korkeampi prioriteetti kuin Volume Data -paketti.",
            "tip2": "Käyttöprioriteetti perustuu samantyyppisen paketin ostopäivään, ts. Varhaisimman ostopäivän pakettiin käytetään ensin, kun taas yhden alueen pakettien prioriteetti on korkeampi kuin alueellinen paketti.",
            "tip3": "Voit myös säätää manuaalisesti samantyyppisten pakettien käytön prioriteettia manuaalisesti."
        },
        "myFlow": "Omat tiedot",
        "remainingFlow": "Tiedot jäljellä",
        "remainingTime": "Aika jäljellä",
        "remainingHighFlow": "Nopeustiedot jäljellä",
        "validPeriod": "Pätevyys",
        "noneFlow": "Ei datapakettia",
        "noneFlowTip": "Osta tietopaketti ja nauti korkealaatuisesta verkosta",
        "buyPackFlow": "Ostaa paketteja",
        "checkInvalidFlow": "Tarkista vanhentunut datapaketti",
        "orderList":  {
            "title": "minun tilauksiani",
            "amount_paid": "Kokonais",
            "device": "Oma laite",
            "order_details": "Tilauksen tiedot",
            "total_amont": "Välisumma",
            "orderSN": "Tilausnro",
            "createTime": "Luomisen aika",
            "cancelTime": "Suljettu aika",
            "payTime": "Tilausaika",
            "unsubTime": "Peruutettu aika",
            "payMethod": "Maksutapa",
            "thirdSN": "Kauppa nro.",
            "delete": "Poistaa",
            "cancel": "Peruuta tilaus",
            "unsub": "Palauttaa",
            "goto_cancel": "Haluatko peruuttaa tilauksen?",
            "goto_unsubscribe": "Haluatko peruuttaa tilauksen?",
            "delete_Tips": "Tilausta ei voida jatkaa poistamisen jälkeen, joten huoltoongelmiasi ei voida käsitellä.Haluatko varmasti poistaa sen?",
            "status_success": "Valmis",
            "status_pending": "Palkaton",
            "status_cancel": "Suljettu",
            "status_unsub": "Peruutettu",
            "payMethod_stripe": "Luottokortti"
          },
    },
    "registerlogin": {
        "create_account_tip":"Luo tili, aloita yksinoikeus",
        "select_country_tip":"Laitteen käyttäminen maata/aluetta",
        "email_name": "Posti",
        "phone_name": "Puhelin",
        "email_address": "Sähköpostiosoite",
        "password": "salasana",
        "country": "maa",
        "select_country": "Valitse maa",
        "cancel": "Peruuttaa",
        "confirm": "Varma",
        "please_enter":"Kirjoita 6-20 merkkiä (kirjaimien, numeroiden tai symbolien yhdistelmä)",
        "select_country_tips": "Maavalinta on tarkoitettu paikallisten pakettien katseluun. Sitä ei voida muuttaa rekisteröinnin jälkeen. Varmista!",
        "global_roaming": "Kansainvälinen verkkotunnuskoodi",
        "phone_number": "puhelinnumero",
        "agree": "sopia",
        "user_agreement": "Käyttäjäsopimus",
        "and": "ja",
        "privacy_policy": "Tietosuojakäytäntö",
        "register_login": "Rekisteröidy tai kirjaudu sisään",
        "login_error": "Tunnisteiden lukumäärä on liian usein, yritä myöhemmin uudelleen!",
        "register_error": "Rekisteröintien lukumäärä on liian usein, yritä myöhemmin uudelleen!",
        "forgot_pwd": "unohda salasana",
        "app_tips": "Kirjaudu sisään sovellukseen tällä tilillä, kun olet ladannut sen, jotta pääset lisää ominaisuuksia.",
        "download_app": "Siirry lataa sovellus",
        "rememberPwd": "Muista salasana",
        "third_login": "Jatkaa jtk",
        "agreement_tips": "Tarkista käyttäjäsopimus ja tietosuojakäytäntöruutu",
        "selectCountry_tips": "Huomaa ystävällisesti, että rekisteröity maa vaikuttaa suoraan seuraaviin maksutapoja ja valuuttoja, valitse tarpeesi mukaan.",
        "login_error_cancel": "Käyttäjä peruutti kirjautumisen",
        "login_error_auth": "Salli ponnahdusikkunat selaimen asetuksista",
        "device_tips": "Laite odottaa aktivointia. Käsitellään 24 tunnissa."
    },
    "forgotPwd": {
        "forgot_pwd": "unohda salasana",
        "email_address": "Sähköpostiosoite",
        "next": "Seuraava",
        "email_has_been_sent": "Olemme lähettäneet sähköpostin %@email. Napsauta linkkiä ja nouta salasanasi.",
        "have_retrieved_it": "Olen löytänyt sen",
        "unable_to_receive_email": "Etkö saa sähköpostia? Ole hyvä ja tarkista, onko %@email sähköpostia roskapostisi ja poistetun postihakemiston alla",
        "or": "tai",
        "resend": "Uudelleensijoittaa uudelleen",
        "global_roaming": "Kansainvälinen verkkotunnuskoodi",
        "phone_number": "puhelinnumero",
        "verification_code_has_been_sent": "Olemme lähettäneet varmennuskoodin osoitteeseen:",
        "verification_code": "Varmennuskoodi",
        "no_verification_code_received": "Etkö saanut varmennuskoodia?",
        "please_enter":"Kirjoita 6-20 merkkiä (kirjaimien, numeroiden tai symbolien yhdistelmä)",
        "reset_password": "Palauta salasana",
        "reset_successful": "Nollata onnistuneesti"
    },
    "coupons": {
        "coupons_name": "Kupongit",
        "no_coupons": "Ei vielä kuponkeja",
        "no_data": "Ei vielä tietoja",
        "applicable_to_the_following": "Kupongit soveltuvat seuraavaan tietopakettiin"
    },
    "digital":{
        "title":"Laite SN",
        "purchased":"Ostokseni",
        "viewAll":"Lisää",
        "skinStore":"Tuotevarasto",
        "completed":"Ostettu",
        "goBuy":"Ostaa",
        "order": {
          "title":"Ostetut tilaukset"
        },
        "detail": {
          "describe":"Kuvaus"
        }
    },
    "viewPL": {
        "other": 'muu'
    },
    "invalidFlow": {
        "stateName": "Status",
        "state": {
            "NOT_ACTIVATED": "Inaktivoitu",
            "IN_USING": "Käytettävissä oleva",
            "USE_END": "Uupunut",
            "EXPIRE": "Vanhentunut",
            "TRANSFER": "Siirtää",
            "UNSUBSCRIBE": "Peruuttaa",
            "VALID": "Pätevä",
            "INVALID": "Virheellinen",
            "EXCHANGE_POINTS": "Lunasta pisteet"
        },
        "noneFlow": "Ei vanhentuneita tietopakettia",
        "pageName": "Vanhentunut datapaketti"
    },
    "flowDetail": {
        "title": "Datatiedot",
        "flow": "Tiedot",
        "validTime": "Voimassa olevat aloitteet",
        "invalidTime": "Voimassa, kunnes",
        "coverage": "Kattavuus",
        "useIntro": "Ehdot",
        "purchaseTime": "Ostettu",
        "subtotal": "Välisumma",
        "status": "Status",
        "cancel": "Peruuttaa",
        "buyAgain": "Osta se uudelleen",
        "validity": "Pätevyys",
        "tip":"Huomautus",
        "cancelTip": "Oletko varma, että haluat palauttaa tämän paketin?",
        "dataLeft": "Tiedot jäljellä"
    },
    "netError": {
        "try_again": "Yrittää uudelleen",
        "net_error": "Ei verkkoa",
        "try_again_desc": "Tarkista verkkoasetus ja yritä uudelleen"
    },
    "loadFail": {
        "try_again": "Yrittää uudelleen",
        "load_fail": "Lastaus epäonnistui",
        "load_fail_desc": "Tietojen lataaminen epäonnistui, yritä uudelleen",
        "IMEI_Not_Exist": "IMEI: tä ei ole, yritä päästä oikealta sisäänkäynnistä",
        "Project_Not_Exist": "Virhe tapahtuu. Ota yhteyttä asiakaspalveluun. (01)",
        "commonError": "Virhe tapahtuu. Ota yhteyttä asiakaspalveluun."
    },
    "settlement_Easy_and_convenient": "Helppo ja kätevä",
    "settlement_Great_deal": "Paljon",
    "settlement_Safe_and_secure": "Turvallinen ja turvallinen",
    "settlement_Autopay_service_regulation": "AutoPay -palvelun sääntely",
    "settlement_Read": "Lukea",
    "settlement_No_coupon": "Ei vielä kuponkeja",
    "settlement_Subtotal": "Välisumma",
    "settlement_Coupon": "Kupongit",
    "settlement_TOTAL": "Kokonais",
    "settlement_promotion_tip": "Mainostarjousta ei voida käyttää yhdessä kuponkien kanssa",
    "settlement_coupon_tip": "Kuponkia ei voida käyttää yhdessä muiden myynninedistämistarjousten kanssa",
    "member_myFlow_noList": "Ei tietoja",
    "detail_se_content": "Turvallinen, helppo ja kätevä tapa. Voit peruuttaa tilauksen milloin tahansa",
    "Enter_Promo_code": "Ylennyskoodi",
    "Enter_Promo_Coupon": "Kupongit",
    "settlement_Not_used_coupon": "Kuponkia ei käytetä",
    "settlement_Available_coupon": "Käytettävissä oleva",
    "settlement_Unavailable_coupon": "Ei käytettävissä",
    "please_Enter_Promo_code": "Anna mainoskoodi",
    "please_Select_Coupon_use": "Valitse käyttämäsi kuponki.",
    "Buy_Now": "Ostaa nyt",
    "Dont_Use_Any": "Älä käytä mitään",
    "settlement_confirm": "Vahvistaa",
    "flowDetail_unsubscribe": "Peruuta tilaus",
    "flowDetail_unsubscribed": "Tilaamaton",
    "flowDetail_isCancelPackage": "Peruuttaa tämä paketti?",
    "flowDetail_confirmAgreementUnsubscribe": "Sinulla ei voi olla paljon tilauksen peruuttamisen jälkeen. Oletko varma, että haluat peruuttaa tilauksen?",
    "flowDetail_cancel": "Peruuttaa",
    "flowDetail_cancelSuccess": "Nollata onnistuneesti",
    "packages_detail_promotion": "Edistäminen",
    "orderTips":{
        "iDay" : "päivä",
        "iDays" : "päivä",
        "iMonth" : "kuukausi",
        "iMonths" : "kuukausi",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Ensimmäisessä ostossasi, Maksa %@money/%@periodSymbol myöhemmin, Voit peruuttaa tilauksen milloin tahansa",
        'Monthly_discount':"Säästä %@saveMoney jokainen %@period! Voit peruuttaa tilauksen milloin tahansa",
        'Ordinary_monthly_package':"Turvallinen, helppo ja kätevä tapa. Voit peruuttaa tilauksen milloin tahansa",
        "AlreadyPurchased":'Valitettavasti voit tilata vain yhden datapaketin tällä hetkellä. Ole hyvä ja peruuta tilaus kohdasta “%@” ja tilaa myöhemmin kaikki haluamasi paketit sen voimassaolon päättymisen jälkeen.',
        "Contract_recommendation_First":'<label>AutoPay -palvelun kanssa, maksa vain ensimmäisessä ostossasi</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Voit peruuttaa tilauksen milloin tahansa'
        +'<a class="btn">Tilata ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>AutoPay -palvelun avulla maksa vain</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Voit peruuttaa tilauksen milloin tahansa'
        +'<a class="btn">Tilata ></a></p>',
        "Contract_recommendation_General":"<label>AutoPay -palvelun kanssa</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Turvallinen, helppo ja kätevä tapa. Voit peruuttaa tilauksen milloin tahansa'
        +'<a href="javascript:;" class="btn">Tilata ></a></p>',
        'BanlanceDoubleCheck':'Oletko varma, että haluat maksaa saldolla?',
    },
    feedback: {
        title: "palaute",
        placeholder: "Ole hyvä ja kirjoita maasta, johon haluat käydä, tai muut kysymykset, ja vastaamme tarpeitasi mahdollisimman pian!",
        submit: "Lähettää",
        submit_success: "Lähetys onnistui",
        other_opinions: "Muut mielipiteet",
    },
    view_country_input: 'Anna tilisi',
    "select_package": {
        "title": "Valitse Tiedot",
        "allPackage": 'Kaikki Tiedot',
        "type": "Tyyppi",
        "flow": "Tiedot",
        "month_package": "Kuukausisuunnitelma",
        "flow_package": "Datapaketti",
        "time": "Kesto",
        "period": "Sykle",
        "auto_debit": "Auto-Otto Info",
        "auto_subscribe": "Auto-Jatkaminen",
        "detail": "Tiedot Yksityiskohdat",
        "carrier": "Tuetut Operaattorit",
        "country": "Peitetyt Maat",
        "notice": "Ostosopas"
    }  
}